import React, { FC, useCallback } from "react";
import {
    amountInDecimal,
    BigText,
    Bold,
    CancelNextButton,
    FinishPageType,
    FlowPage,
    FlowPageProps,
    Highlight,
    intervalTOKey,
    NormalText,
    SmallText,
} from "../cancelFlow";
import "./pages.css";
import { IonButton, IonIcon, IonText } from "@ionic/react";
import { checkmarkCircle, closeCircle } from "ionicons/icons";
import proBadge from "../../../../../assets/images/pro-badge.png";
import plusBadge from "../../../../../assets/images/upgrade-plus-and-pro/plus-badge.png";
import {
    useCurrentStripePlan,
    useStripeSubscription,
    useStripeUpgradePlan,
} from "../../../../../components/hooks";
import { getLocale } from "../../../../../utils/localeUtils";
import { formatForCurrency } from "../../../../../utils/CurrencySymbol";
import * as stripeService from "../../../../../services/StripeService";
import {
    asPlanType,
    planDisplayName,
} from "../../../../../services/StripeService";
import { Trans, useTranslation } from "react-i18next";
import { trackEvent } from "../../../../../services/analytics/analyticsService";
import { ProductBadge } from "../../../../../components/ProductBadge";
import moment from "moment";

const IconPlus = () => {
    return <img src={plusBadge} />;
};
const IconPro = () => {
    return <img src={proBadge} />;
};
const EnabledIcon = () => {
    return (
        <IonIcon
            icon={checkmarkCircle}
            className={"enabled"}
            size={"large"}
        ></IonIcon>
    );
};
const DisabledIcon = () => {
    return (
        <IonIcon
            icon={closeCircle}
            className={"disabled"}
            size={"large"}
        ></IonIcon>
    );
};
const Feature: FC<{ name: string; plus: boolean }> = ({ name, plus }) => {
    return (
        <div className={"feature"}>
            <div className={"name"}>{name}</div>
            <div className={"plus"}>
                {plus ? <EnabledIcon /> : <DisabledIcon />}
            </div>
            <div className={"pro"}>
                <EnabledIcon />
            </div>
        </div>
    );
};

export const OfferDiscountPage: FC<FlowPageProps> = ({
    next,
    finish,
    reason,
}) => {
    const sub = useStripeSubscription();
    const { t } = useTranslation();
    const type = sub?.planFeatures || "";
    // If our current plan is basic, then we are upgrading to pro
    const isUpgrade = asPlanType(type) === "basic";
    const dateTimeFormat = "L";
    const onClickUpgrade = useCallback(
        () =>
            finish &&
            finish(async () => {
                // // Handle the upgrade logic here
                try {
                    await stripeService.applyDiscount();
                    trackEvent("CancellationOutcome", {
                        reason: reason,
                        outcome: "offer-discount-applied",
                    });
                } catch (error) {
                    console.error("Error applying discount:", error);
                }
                return FinishPageType.OfferDiscount;
            }),
        [finish]
    );
    return (
        <FlowPage className={"offer-switch-page"}>
            <ProductBadge type={asPlanType(type)} height={"30px"} />
            <div className={"content"}>
                <BigText>
                    {t("cancellation.screens.offerDiscount.title")}
                </BigText>
                <NormalText>
                    {t("cancellation.screens.offerDiscount.description", {
                        date: moment(sub?.validUntil).format(dateTimeFormat),
                    })}
                </NormalText>
            </div>
            <CancelNextButton next={next} />
            <IonButton
                fill={"solid"}
                onClick={onClickUpgrade}
                data-testid="offer-switch-button"
            >
                <IonText>
                    {t("cancellation.screens.offerDiscount.button")}
                </IonText>
            </IonButton>
        </FlowPage>
    );
};
